import * as types from './types';
import { execApi, execApiWithParam } from '../api/apiActions';
import AuditLogApi from '../../apis/auditlog';


export const getAuditActions = () => {
  return dispatch => {
    dispatch(execApi({
      type: types.GET_AUDIT_ACTIONS,
      api: AuditLogApi.getAuditActions,
      successCallback: response => {
        dispatch({
          type: types.GET_AUDIT_ACTIONS,
          payload: response.actions,
        });
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      useErrorDialog: true,
    }));
  };
};

export const getAuditLog = (data, successCb, errorCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.GET_AUDIT_LOG,
      api: AuditLogApi.getAuditLog,
      param: data,
      successCallback: response => {
        // We also return a "total" key with this response, just fyi.
        dispatch({
          type: types.GET_AUDIT_LOG,
          payload: response.searchResults,
        });
        // We only need to invoke a cb in the AppointmentRequest for internal state
        if (successCb) successCb(response);
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      useErrorDialog: true,
    }));
  };
};



// WEBPACK FOOTER //
// ./src/actions/auditLog/auditLogActions.js